import { ADMIN_BASE_URL, BASE_URL } from "../api_const";


export const ROOFTOP_BASE_URL = BASE_URL + "/services/roof-top"
export const ALL_ROOFTOPS = ROOFTOP_BASE_URL + "/all"
export const CREATE_ROOFTOP = ROOFTOP_BASE_URL + "/create"
export const UPDATE_ROOFTOP = ROOFTOP_BASE_URL + "/update"
export const GET_DETAILS_ROOFTOP_BY_ID = ROOFTOP_BASE_URL
export const ROOFTOPS_SUMMARY = ROOFTOP_BASE_URL + "/summary"
